import { AUTH, UNSET_USER, SET_GLOBAL } from '../actionTypes'
import { userService } from 'src/applets/user'
import { setToken } from 'src/core/helpers/http.helper'

export const doLogout = () => (dispatch: any) => {
  dispatch({ type: SET_GLOBAL, payload: { isLoading: true } })
  userService.doLogout().finally(async () => {
    await setToken(false)
    dispatch({ type: AUTH, payload: { token: null } })
    dispatch({ type: UNSET_USER, payload: {} })
    dispatch({ type: SET_GLOBAL, payload: { isLoading: false } })
  })
}
